var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitalMarketingHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 501.946 501.946",
    style: {
      enableBackground: "new 0 0 501.946 501.946"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M485.03,33.832H21.096c-11.494,0-20.898,9.404-20.898,20.898v321.829h501.551V50.55 C501.749,41.146,494.434,33.832,485.03,33.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M0.198,376.559v39.706c0,11.494,9.404,20.898,20.898,20.898h459.755 c11.494,0,20.898-9.404,20.898-20.898v-39.706H0.198z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CDD6E0"
    },
    cx: 250.973,
    cy: 406.861,
    r: 11.494
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.843,
    y: 437.163,
    style: {
      fill: "#CDD6E0"
    },
    width: 192.261,
    height: 39.706
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M366.957,476.869H134.989c-11.494,0-20.898,9.404-20.898,20.898v4.18H386.81v-4.18 C387.855,486.273,378.451,476.869,366.957,476.869z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.843,
    y: 437.163,
    style: {
      fill: "#ACB3BA"
    },
    width: 192.261,
    height: 15.673
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.634,
    y: 64.134,
    style: {
      fill: "#0d87c5"
    },
    width: 434.678,
    height: 282.122
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2F2F2"
    },
    d: "M340.834,1.44c-21.943,61.649-64.784,96.131-109.714,132.702l56.424,110.759 c56.424-14.629,109.714-29.257,171.363-10.449L340.834,1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M377.406,77.718l36.571,72.098c19.853-10.449,28.212-34.482,17.763-54.335 S397.259,68.314,377.406,77.718z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#40596B"
    },
    points: "280.23,248.036 310.532,308.64 272.916,328.493 233.21,281.473 227.985,275.203 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M231.12,134.142l-59.559,30.302c-10.449,5.224-14.629,17.763-9.404,28.212l37.616,73.143 c5.225,10.449,17.763,14.629,28.212,9.404l59.559-30.302L231.12,134.142z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M161.112,190.567l-3.135,1.045c-7.314,4.18-10.449,13.584-7.314,20.898l25.078,49.11 c4.18,7.314,13.584,10.449,20.898,7.314l3.135-1.045L161.112,190.567z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#334A5E"
    },
    points: "280.23,248.036 284.41,255.35 233.21,281.473 227.985,275.203 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACB3BA"
    },
    d: "M464.132,216.689L357.553,6.665c-3.135-6.269-10.449-8.359-16.718-5.224 c-6.269,3.135-8.359,10.449-5.224,16.718l106.58,210.025c3.135,6.269,10.449,8.359,16.718,5.224 C465.177,230.273,467.267,222.959,464.132,216.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M194.549,0.395H71.251c-11.494,0-21.943,9.404-21.943,21.943v67.918 c0,11.494,9.404,21.943,21.943,21.943h86.727l33.437,33.437v-33.437h3.135c11.494,0,21.943-9.404,21.943-21.943V22.338 C216.492,9.799,206.043,0.395,194.549,0.395z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 183.055,
    cy: 55.775,
    r: 15.673
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 132.9,
    cy: 55.775,
    r: 15.673
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF7058"
    },
    cx: 82.745,
    cy: 55.775,
    r: 15.673
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketingHover);
export default __webpack_public_path__ + "static/media/DigitalMarketingHover.5c41bbdd625f87e982702d1ec18cbe0c.svg";
export { ForwardRef as ReactComponent };